export function parsePrice(price: number) {
  return price / 100;
}
